import { Subject } from 'rxjs';

var RJ_INIT_EVENT = 'RJ_INIT_EVENT';
var RJ_TEARDOWN_EVENT = 'RJ_TEARDOWN_EVENT';
var RJ_DISPATCH_EVENT = 'RJ_DISPATCH_EVENT';
var RJ_ERROR_EVENT = 'RJ_ERROR_EVENT';

var AllRjEventsSubject = new Subject();
var RjDebugEvents = AllRjEventsSubject.asObservable();

export { AllRjEventsSubject as A, RJ_INIT_EVENT as R, RJ_DISPATCH_EVENT as a, RJ_ERROR_EVENT as b, RJ_TEARDOWN_EVENT as c, RjDebugEvents as d };
